import React, { useEffect, useState } from 'react'
import translate from '../../reusable/translate'
import Tooltip from '../tooltip/Tooltip'
import ValueTypeMeter from './ValueTypeMeter'
import RealizedTypeMeter from './RealizedTypeMeter'

import { bindActionCreators } from 'redux'
import { useDispatch, useSelector } from 'react-redux'

import commitmentSlice from '../../../state/slices/commitmentSlice'
import validatorSlice from '../../../state/slices/validatorSlice'
import {getCommitmentTypeId} from "../helpers/Categories";

const Meter = ({ operationMeterId, meter, removeMeter, index, selectedOperation, disabled, operation }) => {

    const [ownMeter, setOwnMeter] = useState(false)
    const { language  } = useSelector((state) => state)
    const dispatch = useDispatch()
    const {
        changeMeterTitle,
        changeMeterValueType,
        changeMeterChartType,
        changeMeterStartingLevel,
        changeMeterTargetLevel,
        resetMeter,
        setMeter
    } = bindActionCreators(commitmentSlice.actions, dispatch)

    useEffect(() => {
        if(meter.meterType_fi_FI) {
            const preDefinedMeter = selectedOperation.meters
                .find((mappedMeter) => mappedMeter.meterType_fi_FI === meter.meterType_fi_FI) //If meter is not in the list, it is most likely custom meter
            if (!preDefinedMeter) {
                setOwnMeter(true)
            } else {
                setOwnMeter(false)
            }
        }
    }, [selectedOperation])

    const changeMeter = (meterType) => {
        const preDefinedMeter = selectedOperation.meters
            .find((mappedMeter) => (mappedMeter.meterType_fi_FI === meterType))

        delete preDefinedMeter['id']
        setMeter(
            { operationId: operation.operationId,
                meterId: meter.meterId,
                preDefinedMeter: {
                    ...preDefinedMeter,
                    meterId: meter.meterId,
                    isNew: true
                }
            })
    }

    const changeMeterName = (name) => {
        changeMeterTitle({ operationId: operation.operationId, meterId: meter.meterId, language: language, meterTitle: name })
    }

    const changeStartingLevel = (value) => {
        changeMeterStartingLevel({ operationId: operation.operationId, meterId: meter.meterId, startingLevel: value })
    }

    const changeTargetLevel = (value) => {
        changeMeterTargetLevel({ operationId: operation.operationId, meterId: meter.meterId, targetLevel: value })
    }

    const changeGraphType = (value) => {
        changeMeterChartType({ operationId: operation.operationId, meterId: meter.meterId, meterChartType: value })
    }

    const addNumericMeter = () => {
        changeMeterValueType({ meterId: meter.meterId, operationId: operation.operationId, meterValueType: 'NUMBER' })
        setOwnMeter(true)
    }

    const addRealizedMeter = () => {
        changeMeterValueType({ meterId: meter.meterId, operationId: operation.operationId, meterValueType: 'REALIZED' })
        setOwnMeter(true)
    }

    const resetAMeter = () => {
        resetMeter( { meterId: meter.meterId, operationId: operation.operationId })
        setOwnMeter(false)
    }

    return(
        <div className="border-bottom section">
            <MeterHeader
                meter={meter}
                removeMeter={removeMeter}
                disabled={disabled}
                index={index}
            />

            {!ownMeter
            &&
            <ChooseMeterContainer
                operationMeterId={operationMeterId}
                selectedOperation={selectedOperation}
                meter={meter}
                changeMeter={changeMeter}
                resetMeter={resetAMeter}
                disabled={disabled}
            />}

            {!ownMeter
            && !meter.meterValueType
            &&
            <AddOwnMeterContainer
                addNumericMeter={addNumericMeter}
                addRealizedMeter={addRealizedMeter}
            />}


            {ownMeter
            &&
            <OwnMeterContainer
                resetMeter={resetAMeter}
                meter={meter}
                changeMeterName={changeMeterName}
                disabled={disabled}
            />}

            {meter.meterValueType === 'REALIZED' &&
            <RealizedTypeMeter/>}

            {meter.meterValueType === 'NUMBER' &&
            <ValueTypeMeter
                meter={meter}
                changeStartingLevel={changeStartingLevel}
                changeTargetLevel={changeTargetLevel}
                changeGraphType={changeGraphType}
                disabled={disabled}
            />}
        </div>
    )
}

export default Meter

const MeterHeader = ({ meter, removeMeter, disabled }) => {
    return(
        <div className={'flex-row space-between items-center meter-header margin-top-bot'}>
            <h4 className="w800">
                {meter.meterType_fi_FI || translate({ textKey: 'sit.commitmentCreation.operationsMeter' })}
            </h4>
            <button
                className="green-button w200"
                onClick={() => removeMeter(meter.meterId)}
                disabled={disabled}
            >
                {translate({ textKey: 'sit.commitment.reports.removeMeter' })} <i className="fas fa-trash"/>
            </button>
        </div>
    )
}

const ChooseMeterContainer = ({ operationMeterId, meter, selectedOperation, changeMeter, resetMeter, disabled }) => {

    const { commitment, validators, language } = useSelector((state) => state)
    const dispatch = useDispatch()
    const { changeOwnMeterValidator } = bindActionCreators(validatorSlice.actions, dispatch)

    return(
        <div className="flex-row items-center">

            <div className="w300 items-center">
                <h4>
                    {translate({ textKey: 'sit.commitment.reports.chooseMeter' })}
                </h4>
                <Tooltip
                    textKey={`tooltip.chooseMeter.${commitment.commitmentSubcategoryId}`}
                    secondaryTextKey={`tooltip.chooseMeter.${commitment.commitmentCategoryId}`}
                    fallback={`tooltip.chooseMeter.general`}
                />
            </div>

            <div className="w800 space-between">
                <select
                    operationMeterId={operationMeterId}
                    className={`select ${validators.ownMeter ? '' : 'select-validated'}`}
                    onChange={(e) => {changeOwnMeterValidator(true); changeMeter(e.target.value)}}
                    value={meter.meterType_fi_FI}
                    disabled={disabled}
                >
                    <option
                        value=""
                    >
                        {translate({ textKey: 'sit.commitment.reports.chooseMeter' })}...
                    </option>

                    {selectedOperation && selectedOperation.meters
                        .sort((a, b) =>
                            (a.meterType_fi_FI.localeCompare(b.meterType_fi_FI)))
                        .map((mappedMeter) =>
                            <option
                                key={mappedMeter.meterType_fi_FI}
                                value={mappedMeter.meterType_fi_FI}
                            >
                                {mappedMeter[`meterType_${language}`]}
                            </option>)}
                </select>

                <button
                    className="green-button"
                    disabled={disabled}
                    onClick={() => resetMeter()}
                >
                    {translate({ textKey: 'sit.commitmentCreation.resetMeter' })}
                </button>
            </div>

        </div>
    )
}

const AddOwnMeterContainer = ({ addNumericMeter, addRealizedMeter }) => {

    return(
        <div className="flex-row margin-top-bot"> {/* meter.meterValueType is used to check if a meter is already selected, as all meters have meterValueType */}
            <div className="w300">
                <div className="flex-row items-center">
                    <h4>
                        {translate({ textKey: 'sit.commitmentCreation.addOwn' })}
                    </h4>
                    <Tooltip textKey={'tooltip.addOwnMeter'}/>
                </div>
            </div>

            <div className="flex-column">
                <div className="flex-row items-center space-between">

                    <button
                        className="green-button margin-top-bot"
                        onClick={() => addNumericMeter()}
                    >
                        {translate({ textKey: 'sit.commitmentCreation.numericMeter' })}
                    </button>

                    <Tooltip textKey={'sit.commitmentCreation.numericMeterInfo'}/>
                </div>
                <div className="flex-row items-center space-between">
                    <button
                        className="green-button"
                        onClick={() => addRealizedMeter()}
                    >
                        {translate({ textKey: 'sit.commitmentCreation.realizedMeter' })}
                    </button>
                    <Tooltip textKey={'tooltip.realizedMeter'}/>
                </div>
            </div>
        </div>
    )

}

const OwnMeterContainer = ({ meter, resetMeter, changeMeterName, disabled }) => {

    const { validators, language } = useSelector((state) => state)
    const dispatch = useDispatch()
    const { changeOwnMeterValidator } = bindActionCreators(validatorSlice.actions, dispatch)

    return(
        <div className="flex-row items center">
            <div className="w300 items-center">
                <h4>
                    {translate({ textKey: 'sit.commitment.reports.nameOfNewMeter' })}
                </h4>
                <Tooltip textKey={`sit.commitmentCreation.ownMeterNameInfo`}
                />
            </div>
            <div className="flex-row space-between w800">
                <input
                    className={`input-text ${validators.ownMeter ? '' : 'input-text-validated'}`}
                    type="text"
                    value={meter[`meterType_${language}`]}
                    disabled={disabled}
                    onChange={(e) => {
                        changeOwnMeterValidator(true)
                        changeMeterName(e.target.value)
                    }}
                />
                <button
                    className="green-button"
                    disabled={disabled}
                    onClick={() => resetMeter()}
                >
                    {translate({
                        textKey: 'sit.commitmentCreation.resetMeter'
                    })}
                </button>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/materialCommitment/meter/Meter.jsx